export default __webpack_public_path__ + "static/media/corazon.54bd6c3a.svg";